import React, { useCallback, useContext } from "react"
import { Navigate, useLocation } from "react-router-dom"
import { adminPagesUrl, pagesUrl } from "@app/core/appConstants"
import { OrganizationContext } from "@app/core/context/organization/OrganizationContext"
import { UserContext } from "@app/core/context/user/UserContext"
import { OrganizationRoleEnum } from "@app/core/enum/user/organization-role-enum"

function isAdminPage(pathname: string | undefined): boolean {
  return !!pathname?.startsWith("/admin/")
}

interface IProps {
  children: React.JSX.Element | null
}

export function RequireNoAuth({ children }: IProps): React.JSX.Element | null {
  const { user } = useContext(UserContext)
  const { organization } = useContext(OrganizationContext)
  const location = useLocation()

  const getHomePageUrl = useCallback((): string => {
    if (user?.role === OrganizationRoleEnum.ULTIMATE_USER) {
      return adminPagesUrl.ADMIN_ORGANIZATION_LIST_PAGE
    } else {
      return pagesUrl.HOME
    }
  }, [user?.role])

  const previousPage = location.state?.from

  if (user) {
    if (user.role === OrganizationRoleEnum.ULTIMATE_USER) {
      if (previousPage && isAdminPage(previousPage)) {
        return <Navigate to={previousPage} replace />
      } else {
        return <Navigate to={getHomePageUrl()} replace />
      }
    } else if (previousPage && !isAdminPage(previousPage)) {
      return <Navigate to={previousPage} replace />
    } else if (organization) {
      return <Navigate to={getHomePageUrl()} replace />
    }
  }

  return children
}
